import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';
import { MediaQueries } from '../../../styles/Grid';

const topBarHeight = 56;
const containerBarHeight = 88;

export const containerCss = css({
  position: 'relative',
  zIndex: 3,
  [MediaQueries.lgAndUp]: {
    position: 'fixed',
    transform: 'translateY(-100%)',
    transition: 'transform 0.3s',
    top: '-48px',
    width: '100%',
    height: containerBarHeight,
    backgroundColor: colorsPalette.white,
    borderBottom: `1px solid ${colorsPalette.grey10}`,
  },
});

export const stickyContainerCss = css({
  [MediaQueries.lgAndUp]: {
    top: 0,
    transform: 'translateY(0)',
  },
});

export const topBarCss = css({
  position: 'fixed',
  transform: 'translateY(-100%)',
  transition: 'transform 0.3s',
  top: 0,
  backgroundColor: colorsPalette.white,
  height: topBarHeight,
  width: '100%',
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  display: 'flex',
  alignItems: 'center',
  [MediaQueries.lgAndUp]: {
    position: 'relative',
    transform: 'none',
    top: 'auto',
    backgroundColor: colorsPalette.transparent,
    height: containerBarHeight,
    border: 0,
  },
});

export const bottomBarCss = css({
  position: 'fixed',
  transform: 'translateY(100%)',
  transition: 'transform 0.3s',
  bottom: 0,
  width: '100%',
  padding: `24px ${Edges[VIEWPORTS.sm]}px`,
  display: 'flex',
  backgroundColor: colorsPalette.white,
  borderTop: `1px solid ${colorsPalette.grey10}`,
  [MediaQueries.mdAndUp]: {
    padding: `24px ${Edges[VIEWPORTS.md]}px`,
    justifyContent: 'flex-end',
  },
  [MediaQueries.lgAndUp]: {
    position: 'absolute',
    transform: 'none',
    top: 'auto',
    right: 0,
    border: 0,
    padding: 0,
    paddingRight: 18,
    backgroundColor: colorsPalette.transparent,
    height: containerBarHeight,
    alignItems: 'center',
    maxWidth: '50%',
  },

  'button, a': {
    [MediaQueries.mdAndUp]: {
      minWidth: 240,
      display: 'inline-block',
      width: 'auto',
    },
    [MediaQueries.lgAndUp]: {
      minWidth: 210,
    },
    ':first-of-type': {
      marginRight: 16,
    },
  },
});

export const stickyInnerBarCss = css({
  transform: 'translateY(0)',
});
